import { render } from "./VaPageNotFoundLargeText.vue?vue&type=template&id=3fa07e4d"
import script from "./VaPageNotFoundLargeText.vue?vue&type=script&lang=js"
export * from "./VaPageNotFoundLargeText.vue?vue&type=script&lang=js"

import "./VaPageNotFoundLargeText.vue?vue&type=style&index=0&id=3fa07e4d&lang=scss"
script.render = render

export default script